import { Box, Button, Chip, Stack, styled, Typography } from '@mui/material';
import { Breadcrumbs } from './components/Breadcrumbs/Breadcrumbs.js';
export const FormBuilderWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '0 1.5rem',
    marginTop: '5svh',
    [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(16),
    },
    [theme.breakpoints.up('md')]: {
        marginTop: theme.spacing(24),
    },
    [theme.breakpoints.up('lg')]: {
        marginTop: theme.spacing(28),
    },
}));
export const StepWrapper = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    flex: 1,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    transition: 'all 0.5s ease',
    ['.fade-enter']: {
        opacity: 0,
        [theme.breakpoints.up('md')]: {
            transform: 'translateY(-100%)',
        },
    },
    ['.fade-enter-active']: {
        opacity: 1,
        [theme.breakpoints.up('md')]: {
            transform: 'translateY(0%)',
        },
    },
    ['.fade-exit']: {
        opacity: 1,
        [theme.breakpoints.up('md')]: {
            transform: 'translateY(0%)',
        },
    },
    ['.fade-exit-active']: {
        opacity: 0,
        [theme.breakpoints.up('md')]: {
            transform: 'translateY(100%)',
        },
    },
    ['.fade-enter-active,.fade-exit-active']: {
        transition: 'opacity 400ms, transform 400ms',
    },
    ['.fade-out-enter']: {
        opacity: 0,
        [theme.breakpoints.up('md')]: {
            transform: 'translateY(100%)',
        },
    },
    ['.fade-out-enter-active']: {
        opacity: 1,
        [theme.breakpoints.up('md')]: {
            transform: 'translateY(0%)',
        },
    },
    ['.fade-out-exit']: {
        opacity: 1,
        [theme.breakpoints.up('md')]: {
            transform: 'translateY(0%)',
        },
    },
    ['.fade-out-exit-active']: {
        opacity: 0,
        [theme.breakpoints.up('md')]: {
            transform: 'translateY(-100%)',
        },
    },
    ['.fade-out-enter-active,.fade-out-exit-active']: {
        transition: 'opacity 400ms, transform 400ms',
    },
}));
export const StyledBreadCrumbs = styled(Breadcrumbs)(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
        display: 'block',
    },
}));
export const StepIndicator = styled(Chip)(({ theme }) => ({
    width: 'fit-content',
    alignSelf: 'end',
    [theme.breakpoints.up('sm')]: {
        alignSelf: 'start',
    },
}));
/**
 * Visually hidden Typography component for screen readers (accessibility).
 */
export const ScreenReaderText = styled(Typography)({
    // size cant be 0 as it causes some readers to skip the element
    width: '1px',
    height: '1px',
    // ensure the element is visually hidden and occupies no visual space
    position: 'absolute',
    padding: '0',
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: '0',
    background: 'none',
});
export const ButtonWrapper = styled(Stack)(({ theme }) => ({
    position: 'fixed',
    left: 0,
    bottom: 0,
    right: 0,
    width: '100%',
    gap: theme.spacing(3),
    padding: theme.spacing(4, 6),
    backgroundColor: theme.palette.background.default,
    zIndex: 1,
    [theme.breakpoints.up('sm')]: {
        gap: theme.spacing(4),
        position: 'relative',
        flexDirection: 'row',
        padding: 0,
        margin: '1rem 0',
        backgroundColor: 'transparent',
    },
}));
export const StyledButton = styled(Button)(({ theme }) => ({
    padding: `${theme.spacing(3)} !important`,
    // switch order with 2nd button
    ['&:first-of-type']: {
        order: 2,
    },
    // switch order with 1st button
    ['&:last-of-type']: {
        order: 1,
    },
    [theme.breakpoints.up('sm')]: {
        padding: `${theme.spacing(4)} !important`,
        // reset order
        ['&:first-of-type']: {
            order: 'unset',
        },
    },
}));
//# sourceMappingURL=data:application/json;base64,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